import type { JSendError, JSendFail } from './APIResponse';

export class APIError extends Error {
  status: 'success' | 'fail' | 'error' = 'error';

  code: number = 0;

  constructor(message: string | JSendFail | JSendError, code?: number) {
    if (typeof message === 'object') {
      super(message.message);
      this.status = message.status;
      if (message.code) {
        this.code = message.code;
      }
      return;
    }
    super(message);
    if (code) {
      this.code = code;
    }
  }
}
